import { Output, ViewChild } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { tick } from '@angular/core/testing';
import { DataTableDirective } from 'angular-datatables';
import { extend } from 'jquery';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { title } from 'process';
import { Subject } from 'rxjs';

import * as XLSX from 'xlsx';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';


import { ExportToCsv } from 'export-to-csv';

@Component({
  selector: 'app-view-roamers-segment-data',
  templateUrl: './view-roamers-segment-data.component.html',
  styleUrls: ['./view-roamers-segment-data.component.scss']
})
export class ViewRoamersSegmentDataComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false }) dtElement: DataTableDirective;
  dtOptions: any = {};
  @Input() tableData: any;
  @Output() refreshTableData = new EventEmitter();
  dtTrigger: Subject<any> = new Subject();
  @Input() cameFrom: any;
  title:  any;
  fileName : any;
  dataToBeDownloaded: any =[];
  
  

  constructor(private spinnerService: Ng4LoadingSpinnerService,  private endpointsService: EndpointsService,
    private backendApiService: BackendApiService, ) { }

  ngOnInit() {
    if(this.cameFrom == 'RoamersSegment'){
          this.title= 'RoamersSegment'
    }
          if(this.cameFrom == 'RoamersCountHistory'){
            this.title=  'Roamers Count History'

            for(var i=0; i<=this.tableData.length-1 ; i++)
            {
              this.dataToBeDownloaded.push({'S No.': (i+1) ,Date: this.tableData[i].created_date_time ,
                 Country: this.tableData[i].cntryName, Operator: this.tableData[i].cntryOperator, 
               'Success Requests' :this.tableData[i].successInRequest,'Failed Requests' :this.tableData[i].failedInRequest,
               'Total Requests' :this.tableData[i].totalInRequest,
              });
              
        
            }
          }
          if(this.cameFrom == 'PricePointHistory'){
            this.title=  'Price Point History'

            for(var i=0; i<=this.tableData.length-1 ; i++)
            {
              this.dataToBeDownloaded.push({'S No.': (i+1) ,'Created Date': this.tableData[i].createdDate ,
                 Country: this.tableData[i].cntryName, Operator: this.tableData[i].cntryOperator, 
               'Price Plan Applied' :this.tableData[i].pricePlanApplied
              });
              
        
            }
          }
          if(this.cameFrom == 'RoamersPackHistory'){
            this.title=  'Roamers Pack History'

            for(var i=0; i<=this.tableData.length-1 ; i++)
            {
              this.dataToBeDownloaded.push({'S No.': (i+1) ,'Created Date': this.tableData[i].createdDate ,
                 Country: this.tableData[i].cntryName, Operator: this.tableData[i].cntryOperator, 
               'Roam Free Pack' :this.tableData[i].RoamFreePack, 'Standard Pack' :this.tableData[i].standardPack
              });
              
        
            }
          }
          if(this.cameFrom == 'RoamfreeInErrorCode'){
            this.title=  'Roam Free In ErrorCode'
            for(var i=0; i<=this.tableData.length-1 ; i++)
            {
              this.dataToBeDownloaded.push({'S No.': (i+1) ,'Created Date': this.tableData[i].created_date_time ,
                 Country: this.tableData[i].cntryName, Operator: this.tableData[i].cntryOperator, 
               'Total In Request' :this.tableData[i].totalInRequest, 'Error Code' :this.tableData[i].error_code,
              'Error Reasons' : this.tableData[i].error_reason});
              
        
            }
          }
          if(this.cameFrom == 'inStatistics'){
            this.title=  'In Statistics'
            for(var i=0; i<=this.tableData.length-1 ; i++)
            {
              this.dataToBeDownloaded.push({'S No.': (i+1) ,'Created Date': this.tableData[i].createdDate ,
              Country: this.tableData[i].cntryName , Operator: this.tableData[i].cntryOperator,
            Roamers: this.tableData[i].roamers, '0_10': this.tableData[i].zeroTOTen,  '10_20': this.tableData[i].tenToTwenty,
            '20_30': this.tableData[i].tewntyTOThirty, '30_plus' : this.tableData[i].thirtyPlus });
               }
            
            }
          if(this.cameFrom == 'messageCount'){
            this.title=  'Message Count'

            for(var i=0; i<=this.tableData.length-1 ; i++)
            {
              this.dataToBeDownloaded.push({'S No.': (i+1) ,Date: this.tableData[i].createdDate ,
                 Country: this.tableData[i].cntryName, Operator: this.tableData[i].cntryOperator, 
                Success :this.tableData[i].success, Failed: this.tableData[i].failed, Total :this.tableData[i].total,
                Message: this.tableData[i].msg});
              
        
            }
            
            console.log("this.dataToBeDownloaded",this.dataToBeDownloaded)
          }
          if(this.cameFrom == 'MessageDeliveryStatistics'){
            this.title=  'MessageDeliveryStatistics'
          }
          if(this.cameFrom == 'repitiveCount'){
            this.title=  'RRMS Unique MSISDN Count'
            
            for(var i=0; i<=this.tableData.length-1 ; i++)
            {
              this.dataToBeDownloaded.push({'S No.': (i+1) ,MSISDN: this.tableData[i].msisdn ,
                 Type: this.tableData[i].type, Country: this.tableData[i].cntryName, 
               Operator :this.tableData[i].cntryOperator, 'Total Count' :this.tableData[i].total_count});
              
        
            }
          }
          if(this.cameFrom == 'vlridunblockCount'){
            this.title=  'RRMS Vlrid Delete Offer Count'

            for(var i=0; i<=this.tableData.length-1 ; i++)
            {
              this.dataToBeDownloaded.push({'S No.': (i+1) ,'Created Date': this.tableData[i].created_date_time ,
                 'Total Count': this.tableData[i].total_count, Type: this.tableData[i].type, 
              });
              
        
            }
          }
    this.dtOptions = {
      paging: true,
      pagingType: 'full_numbers',
      scroller: true,
      scrollCollapse: true,
      scrollX: true,
      responsive: true,
      select: true,
      dom: '<\'row\'<\'col-sm-12 col-md-3\'l><\'col-sm-12 col-md-3\'B><\'col-sm-12 col-md-6\'f>>' +
        '<\'row\'<\'col-sm-12\'tr>>' +
        '<\'row\'<\'col-sm-12 col-md-3 entries\'i><\'col-sm-12 col-md-9 entries\'p>>',
      buttons: [
          
       
        {
          text: 'CSV',
          action: () => {
            
           //this.downloadcsv(this.tableData , this.title);
           this.downloadcsv(this.dataToBeDownloaded, this.title);
          
            this.storeAnalytics();
          },
        },
        {
          text: 'EXCEL',
          action: () => {
            
            this.exportTable(this.title);
            this.storeAnalytics();
          },
        },
      ],
      
    };
  }
  public downloadcsv(serviceSummaryData, title) {
    console.log('serviceSummaryData ', serviceSummaryData);
    var data1 = document.getElementById('view-table');
    const options = {
      filename: title,
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
      // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
    };
    const csvExporter = new ExportToCsv(options);
    csvExporter.generateCsv(serviceSummaryData);
  }
  
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  // exportTable(title) {
  //   /* pass here the table id */
  //   let element = document.getElementById(title);
  //   const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
  
  //   /* generate workbook and add the worksheet */
  //   const wb: XLSX.WorkBook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  
  //   /* save to file */
  //   XLSX.writeFile(wb, title+'.xlsx');
  
  //   // alert('asdf');
  // }
  exportTable(title) {
    //const workSheet = XLSX.utils.json_to_sheet(this.tableData);
    const workSheet = XLSX.utils.json_to_sheet(this.dataToBeDownloaded);
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, 'SheetName');
    XLSX.writeFile(workBook, title+'.xlsx');
}
   

 
 storeAnalytics() {
    
  if(this.cameFrom == 'messageCount'){
   
    const apiUrl1 = this.endpointsService.CENTRY_LOG +
      'userName=' + sessionStorage.getItem('ecowas_user_name') + '&action=Reports' + '&module=Message Count' + '&operation=download' + '&opname=is_downloaded' + '&opvalue=true';
    this.backendApiService.callToApi(apiUrl1).subscribe(response => {
     console.log(response);
    });

  }

  if(this.cameFrom == 'RoamersSegment'){
    const apiUrl1 = this.endpointsService.CENTRY_LOG +
    'userName=' + sessionStorage.getItem('ecowas_user_name') + '&action=Reports' + '&module=Message Count' + '&operation=download' + '&opname=is_downloaded' + '&opvalue=true';
  this.backendApiService.callToApi(apiUrl1).subscribe(response => {
   console.log(response);
  });
}
    if(this.cameFrom == 'RoamersCountHistory'){
      const apiUrl1 = this.endpointsService.CENTRY_LOG +
      'userName=' + sessionStorage.getItem('ecowas_user_name') + '&action=Reports' + '&module=Roamers Count History' + '&operation=download' + '&opname=is_downloaded' + '&opvalue=true';
    this.backendApiService.callToApi(apiUrl1).subscribe(response => {
     console.log(response);
    });
    }
    if(this.cameFrom == 'PricePointHistory'){
      const apiUrl1 = this.endpointsService.CENTRY_LOG +
      'userName=' + sessionStorage.getItem('ecowas_user_name') + '&action=Reports' + '&module=Price Point History' + '&operation=download' + '&opname=is_downloaded' + '&opvalue=true';
    this.backendApiService.callToApi(apiUrl1).subscribe(response => {
     console.log(response);
    });
    }
    if(this.cameFrom == 'RoamersPackHistory'){
      const apiUrl1 = this.endpointsService.CENTRY_LOG +
      'userName=' + sessionStorage.getItem('ecowas_user_name') + '&action=Reports' + '&module=Roamers Pack History' + '&operation=download' + '&opname=is_downloaded' + '&opvalue=true';
    this.backendApiService.callToApi(apiUrl1).subscribe(response => {
     console.log(response);
    });
    }
    if(this.cameFrom == 'RoamfreeInErrorCode'){
      const apiUrl1 = this.endpointsService.CENTRY_LOG +
      'userName=' + sessionStorage.getItem('ecowas_user_name') + '&action=Reports' + '&module=Roam free In Error Code' + '&operation=download' + '&opname=is_downloaded' + '&opvalue=true';
    this.backendApiService.callToApi(apiUrl1).subscribe(response => {
     console.log(response);
    });
    }
    if(this.cameFrom == 'inStatistics'){
      const apiUrl1 = this.endpointsService.CENTRY_LOG +
      'userName=' + sessionStorage.getItem('ecowas_user_name') + '&action=Reports' + '&module=In Statistics' + '&operation=download' + '&opname=is_downloaded' + '&opvalue=true';
    this.backendApiService.callToApi(apiUrl1).subscribe(response => {
     console.log(response);
    });
    }
    if(this.cameFrom == 'MessageDeliveryStatistics'){
      const apiUrl1 = this.endpointsService.CENTRY_LOG +
      'userName=' + sessionStorage.getItem('ecowas_user_name') + '&action=Reports' + '&module=Message Delivery Statistics' + '&operation=download' + '&opname=is_downloaded' + '&opvalue=true';
    this.backendApiService.callToApi(apiUrl1).subscribe(response => {
     console.log(response);
    });
    }
    if(this.cameFrom == 'repitiveCount'){
      const apiUrl1 = this.endpointsService.CENTRY_LOG +
      'userName=' + sessionStorage.getItem('ecowas_user_name') + '&action=Reports' + '&module=RRMS Unique MSISDN Count' + '&operation=download' + '&opname=is_downloaded' + '&opvalue=true';
    this.backendApiService.callToApi(apiUrl1).subscribe(response => {
     console.log(response);
    });
    }
    if(this.cameFrom == 'vlridunblockCount'){
      const apiUrl1 = this.endpointsService.CENTRY_LOG +
      'userName=' + sessionStorage.getItem('ecowas_user_name') + '&action=Reports' + '&module=Vlrid Delete Offer Count' + '&operation=download' + '&opname=is_downloaded' + '&opvalue=true';
    this.backendApiService.callToApi(apiUrl1).subscribe(response => {
     console.log(response);
    });
    }
  }
}
